export default "__VITE_ASSET__BTR0VuDT__"